import { FaWhatsapp } from "react-icons/fa";
import { mainContact, whatsappUrl } from "../../data/artemulkContent";

function Whatsapp1() {
  return (
    <div className="whatsapp-btn-container">
      <a
        className="whatsapp-fab"
        href={whatsappUrl()}
        target="_blank"
        rel="noreferrer"
        aria-label={`WhatsApp: ${mainContact.whatsapp}`}
      >
        <FaWhatsapp className="whatsapp-fab-icon" />
      </a>
    </div>
  );
}

export default Whatsapp1;
